import { SVGProps, Ref, forwardRef } from 'react';

export const TrashOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M7.032 12.664V6.665h-1.4v5.999z" fill="currentColor" />
                <path d="M10.364 6.665v5.999h-1.4V6.665z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.68 3.3h3.82v1.4h-1.504v5.964c0 4-1.333 5.332-5.332 5.332H7.331C3.332 15.996 2 14.663 2 10.664V4.7H.5V3.3h3.817C4.81 1.43 5.928 0 7.998 0s3.188 1.429 3.681 3.3m-1.46 0a4.4 4.4 0 0 0-.322-.746c-.415-.748-.982-1.154-1.9-1.154s-1.485.406-1.9 1.154q-.185.334-.322.746zM3.4 4.7h9.196v5.964c0 1.922-.338 2.758-.756 3.176s-1.254.756-3.176.756H7.331c-1.922 0-2.757-.338-3.175-.756s-.757-1.254-.757-3.176z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
TrashOutlinedSize16Glyph.displayName = 'TrashOutlinedSize16Glyph';
